export default {
  index: {
    proList: 'product/productlist',
    proDetail: 'product/product',
    banner: 'publics/banner',
    newList: 'new/newList',
    newDetail: 'new/newDetail',
    readyNews: 'new/ready',
    login: 'user/login',
    creatOrder: 'order/create',
    orderList: 'order/orderList',
    orderDetail: 'order/orderDetail',
    searchProduct: 'product/search',
    customOrder: 'order/customCreate',
    customOrderList: 'order/customOrderList',
    customProductOrderList: 'order/customProductOrderList',
  }

}



// WEBPACK FOOTER //
// ./src/server/api.js